export default {
  en: "EN | English",
  mn: "MN | Mongolia",
  
  all: "All",
  attention: "Attention",
  amount: "Amount",
  account: "Account",
  account_name: "Account Name",
  account_number: "Account No.",
  account_opening: "Account Opening",
  account_closing: "Account Closing",
  account_balance: "Account Balance",
  attachment_info: "Attachment Information",
  approved: "Approved",
  account_id: "Account ID",
  accumulate_turnover: "Accumulate Turnover",

  bank_details: "Bank Details",
  bank: "Bank",
  bank_name: "Bank Name",
  bet_history: "Bet History",
  bet_count: "Bet Count",
  back_to_top: "Back To Top",
  bet_id: "Bet ID",
  bet_time: "Bet Time",
  bonus: "Bonus",
  balance: "Balance",

  casino: "Casino",
  copyright: "Copyright © 2024 {brand}. | All rights reserved.",
  contact_livechat: "Contact {brand} Livechat",
  choose_file: "Choose File",
  cancel: "Cancel",
  commission: "Commission",
  category: "Category",
  contact_phone: "Contact Phone",
  contact_email: "Contact Email",
  contact_no_phone: "Contact (Phone)",
  contact_no_viber: "Contact (Viber)",
  copy: "Copy",
  criteria: "Criteria",
  coming_soon: "Coming soon",

  date: "Date",
  download: "Download",
  deposit: "Deposit",
  deposit_channel: "Deposit Channel",
  deposit_methods: "Deposit Methods",
  deposit_options: {
    online_banking: "Online Banking",
    atm_transfer: "ATM Transfer",
    cash_deposit: "Cash Deposit"
  },

  event: "Event",
  eta: "ETA",

  full_name: "Full Name",
  failed: "Failed",
  fish: "Fishing",
  favorite: "Favorite",
  follow_us: "Follow us",
  footermenu: {
    about_us: "About Us",
    privacy_policy: "Privacy Policy",
    responsible_gaming: "Responsible Gaming",
    banking: "Banking",
    faqs: "FAQs"
  },
  forgot_password: "Forgot Password",

  game_name: "Game Name",

  hot: "Hot",

  login: "Login",
  lottery: "Lottery",
  lost: "Lost",
  last_4digits_contact: "Last 4 Digits of Contact Phone",

  mission: "Mission",  
  minimum_amount: "Minimum amount",
  maximum_amount: "Maximum amount",
  min_deposit: "Min Deposit",

  no_record: "No Record Found",
  
  odds: "Odds",
  others: "Others",

  password: "Password",
  password_current: "Current Password",
  password_new: "New Password",
  password_confirm: "Confirm Password",
  password_change: "Change Password",
  poker: "Poker",
  promo: "Promo | Promotions",
  provider: "Provider",
  payment_method: "Payment Method",
  pending: "Pending",

  qrcode: "QRCode",

  rebate_amount: "Rebate Amount",
  rebate_details: "Rebate Details",
  rebate_balance: "Rebate Balance",
  rebate: "Rebate",
  read_more: "Read More",
  receipt: "Receipt",
  refno: "No. Ref",
  request_type: "Request Type",
  remark: "Remark",
  register: "Register",
  registration: "Registration",
  request_tac: "Request TAC",
  rollover: "Rollover",
  
  slot: "Slots",
  sports: "Sports",
  search_game: "Search Game",
  statement: "Statement",
  submit: "Submit",
  success: "Success",
  save: "Save",
  settlement: "Settlement",
  status: "Status",
  stake: "Stake",
  soccer: "Soccer",

  target_amount: "Target Amount",
  transfer_type: "Transfer Type",
  transfer_history: "Transfer History",
  tac_code: "TAC Code",
  transfer: "Transfer",
  turnover: "Turnover",
  transaction_history: "Transaction History",
  tournament: "Tournament",
  tooltips: {
    deposit_amount: "Please insert amount (Min {minbet})",
    deposit_min: "*Please insert the minimum deposit amount",
    select_promotion: "Please select a promotion",
    file_upload: "File size cannot exceed 1mb and must be in png, jpg or jpeg format",
    unsupported_format: "Unsupported file type. Please choose a valid image file.",
    withdraw_amount: "Please insert amount (Min {min} | Max {max})",
    max_withdraw_count: "Member only can submit {count} withdrawal ticket(s) per day.",
    rebate_amount: "Please insert amount (Min {min} | Max {max})",
    bank_empty_info: "Please refer to our customer service for banking information.",
    copy_qrcode: "QR code url has been copied to the clipboard",
    last_4digits_contact: "Please key in the last 4 digits of your contact phone.",
    tac_livechat: "If you still failed to receive your TAC code, kindly contact our customer service via livechat for further assistance.",
    announcement: "Welcome to UBWIN, Mongolia's Trusted Online Casino. Experience quick deposits, fast payouts and greatest trust with UBWIN for an unparalleled gaming experience filled with big wins."
  },
  transfer_amount: "Transfer Amount",

  username: "Username",

  valid_turnover: "Valid turnover",

  withdraw: "Withdraw",
  winlose: "Win/Lose",
  win: "Win",
  welcome: "Welcome",
};
